import React from "react";
import { ChevronDown } from "lucide-react";
import { useLang } from "../i18n";
import { useNavigate } from "react-router-dom";
import { HERO_IMAGE } from "../data";
import OliveBranch from "./OliveBranch";

export const Hero = () => {
  const { t } = useLang();
  const navigate = useNavigate();

  const scrollTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="home" className="relative min-h-[100svh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="Terrasse der Pizzeria Quattro Stelle"
          className="w-full h-full object-cover grayscale animate-kenburns"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/80" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_30%,rgba(0,0,0,0.5)_100%)]" />
      </div>

      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto pt-20">
        <div className="flex flex-col items-center reveal is-visible" style={{ transitionDelay: "100ms" }}>
          <OliveBranch className="w-28 text-qs-gold mb-5" />
          <p className="font-outfit text-qs-gold tracking-[0.4em] uppercase text-[11px] md:text-xs mb-6">
            {t.hero.eyebrow}
          </p>
          <h1 className="font-cormorant text-white text-[2.6rem] leading-[1.05] sm:text-6xl lg:text-7xl font-medium text-balance">
            {t.hero.title}
          </h1>
          <p className="font-outfit text-white/85 text-base md:text-lg mt-6 max-w-2xl leading-relaxed">
            {t.hero.subtitle}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 mt-10 w-full sm:w-auto">
            <button
              data-testid="hero-cta-reserve"
              onClick={() => scrollTo("contact")}
              className="bg-qs-red text-white hover:bg-qs-reddark transition-all duration-300 rounded-full px-9 py-4 text-xs font-semibold tracking-[0.14em] uppercase hover:scale-[1.02] active:scale-95"
            >
              {t.hero.reserve}
            </button>
            <button
              data-testid="hero-cta-menu"
              onClick={() => navigate("/speisekarte")}
              className="border border-qs-gold text-white hover:bg-qs-gold hover:text-black transition-all duration-300 rounded-full px-9 py-4 text-xs font-semibold tracking-[0.14em] uppercase active:scale-95"
            >
              {t.hero.menu}
            </button>
          </div>
        </div>
      </div>

      <button
        onClick={() => scrollTo("about")}
        className="absolute bottom-7 left-1/2 -translate-x-1/2 z-10 text-white/70 hover:text-qs-gold transition-colors animate-bounce"
        aria-label="scroll down"
      >
        <ChevronDown size={30} strokeWidth={1.4} />
      </button>
    </section>
  );
};

export default Hero;
